module.exports = __webpack_public_path__ + "static/media/logo.8ae44df1.svg";